





































import { Component, Vue, Prop, Emit } from 'vue-property-decorator';

@Component
export default class PaymentDialog extends Vue {
  paymentDialog: boolean = true;
  paymentWindowOpened: boolean = false;
  paymentWindow: Window | null = null;
  checkWindowClosedInterval: number | null = null;
  urlCheckAttempts: number = 0;
  maxUrlCheckAttempts: number = 10; // Maksimum 10 deneme (5 saniye)

  mounted() {
    // Dialog açıldığında önce mesajı göster, sonra ödeme penceresini aç
    this.paymentWindowOpened = true; // Önce mesajı göster
    this.$nextTick(() => {
      // URL hazır olana kadar bekleyen bir fonksiyon çağır
      this.waitForPaymentUrl();
    });
  }

  handleDialogInput(value: boolean) {
    // Dialog manuel olarak kapatılırsa ödeme penceresini de kapat
    if (!value && this.paymentWindow && !this.paymentWindow.closed) {
      this.paymentWindow.close();
    }
  }

  closeDialog() {
    if (this.paymentWindow && !this.paymentWindow.closed) {
      this.paymentWindow.close();
    }
    this.$emit('closed');
  }

  // Yanıtın URL veya HTML olup olmadığını kontrol et
  isResponseUrl() {
    const response = this.$store.state.payment.response;
    // Eğer yanıt http:// veya https:// ile başlıyorsa URL'dir
    return response && (response.startsWith('http://') || response.startsWith('https://'));
  }
  
  // HTML içeriğini yeni pencerede açmak için Blob URL oluştur
  createBlobUrl() {
    const htmlContent = this.$store.state.payment.response;
    if (!htmlContent) return null;
    
    // HTML içeriğinden Blob oluştur
    const blob = new Blob([htmlContent], { type: 'text/html' });
    return URL.createObjectURL(blob);
  }
  
  // Ödeme yanıtının hazır olmasını bekleyen fonksiyon
  waitForPaymentUrl() {
    const response = this.$store.state.payment.response;
    
    if (response) {
      // Yanıt hazır, ödeme penceresini aç
      this.openPaymentWindow();
    } else {
      // Yanıt henüz hazır değil, tekrar dene
      this.urlCheckAttempts++;
      
      if (this.urlCheckAttempts < this.maxUrlCheckAttempts) {
        // 500ms sonra tekrar dene
        setTimeout(() => {
          this.waitForPaymentUrl();
        }, 500);
      } else {
        // Maksimum deneme sayısına ulaşıldı
        // Sessizce başarısız ol, kullanıcı zaten mesajı görüyor
      }
    }
  }

  // Mobil cihaz olup olmadığını kontrol et
  isMobileDevice() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || 
           (navigator.userAgent.includes('Mobile') && navigator.userAgent.includes('Safari'));
  }

  openPaymentWindow() {
    // Eğer zaten açık bir ödeme penceresi varsa, onu kapat ve referansı temizle
    if (this.paymentWindow && !this.paymentWindow.closed) {
      try {
        this.paymentWindow.close();
      } catch (e) {
        // Kapatma sırasında hata olursa görmezden gel (çapraz köken sorunları olabilir)
      }
      this.paymentWindow = null;
    }

    let url;
    
    // Yanıtın tipine göre URL belirle
    if (this.isResponseUrl()) {
      // Doğrudan URL ise (Ruble için)
      url = this.$store.state.payment.response;
    } else {
      // HTML içerik ise (Diğer para birimleri için)
      url = this.createBlobUrl();
    }
    
    if (!url) {
      return;
    }
    
    // Mobil cihaz kontrolü yap
    const isMobile = this.isMobileDevice();
    
    if (isMobile) {
      // Mobil cihazlarda aynı pencerede aç
      window.location.href = url;
      return;
    } else {
      // Masaüstü cihazlarda popup pencere aç
      const width = 1000;
      const height = 700;
      const left = (window.screen.width - width) / 2;
      const top = (window.screen.height - height) / 2;
      
      try {
        this.paymentWindow = window.open(
          url,
          'PaymentWindow',
          `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes,status=yes`
        );
        
        if (this.paymentWindow) {
          // Ödeme penceresi başarıyla açıldı
          this.setupPaymentWindowListener();
          
          // Ödeme penceresinin yönlendirmelerini izle
          if (this.paymentWindow.location) {
            this.monitorPaymentWindowRedirects();
          }
        }
      } catch (error) {
        // Popup açılamadıysa, yeni sekmede aç
        this.paymentWindow = window.open(url, '_blank');
        this.setupPaymentWindowListener();
      }
    }
  }

  setupPaymentWindowListener() {
    // Popup penceresi kapandığında veya tamamlandığında kontrol et
    this.checkWindowClosedInterval = window.setInterval(() => {
      if (this.paymentWindow && this.paymentWindow.closed) {
        if (this.checkWindowClosedInterval) {
          clearInterval(this.checkWindowClosedInterval);
          this.checkWindowClosedInterval = null;
        }
        // Ödeme penceresi kapandığında dialog'u da kapat
        this.paymentWindowOpened = false;
        this.closeDialog();
      }
      
      // Ödeme tamamlandığında açılan charterscanners.ru/1.html sayfasını kontrol et
      this.checkForSuccessPage();
    }, 500);
    
    // Mesaj dinleyicisini kur
    window.addEventListener('message', this.handleMessage, false);
  }

  handleMessage(event: MessageEvent) {
    if (event.data === 'paymentCompleted') {
      if (this.paymentWindow && !this.paymentWindow.closed) {
        this.paymentWindow.close();
      }
      this.closeDialog();
    }
  }

  // Ödeme tamamlandığında açılan charterscanners.ru/1.html sayfasını kontrol et ve kapat
  checkForSuccessPage() {
    try {
      // Eğer ödeme penceresi açıksa ve erişilebiliyorsa
      if (this.paymentWindow && !this.paymentWindow.closed) {
        // Güvenlik nedeniyle try-catch içinde kontrol ediyoruz (çapraz köken erişimi hatası olabilir)
        try {
          const currentUrl = this.paymentWindow.location.href;
          
          // Eğer charterscanners.ru/1.html sayfasına yönlendirildiyse
          if (currentUrl && currentUrl.includes('charterscanners.ru/1.html')) {
            // Sayfayı kapat ve dialog'u kapat
            this.paymentWindow.close();
            this.closeDialog();
          }
        } catch (e) {
          // Çapraz köken erişimi hatası olabilir, görmezden gel
        }
      }
    } catch (error) {
      // Hata durumunda sessizce devam et
    }
  }
  
  // Ödeme penceresinin yönlendirmelerini izle
  monitorPaymentWindowRedirects() {
    if (!this.paymentWindow) return;
    
    try {
      // MutationObserver ile sayfa değişikliklerini izlemeye çalış
      // Not: Güvenlik kısıtlamaları nedeniyle çalışmayabilir
      const originalWindow = this.paymentWindow;
      
      // Pencere yönlendirmelerini yakalamak için
      originalWindow.onunload = () => {
        // Yeni URL'yi kontrol et (bir sonraki tick'te)
        setTimeout(() => {
          this.checkForSuccessPage();
        }, 100);
      };
    } catch (error) {
      console.error('Yönlendirme izleme hatası:', error);
    }
  }
  
  beforeDestroy() {
    // Bileşen yok edilmeden önce event listener'ı kaldır
    window.removeEventListener('message', this.handleMessage);
    
    // Interval'i temizle
    if (this.checkWindowClosedInterval) {
      clearInterval(this.checkWindowClosedInterval);
      this.checkWindowClosedInterval = null;
    }
    
    // Açık kalan ödeme penceresini kapat
    if (this.paymentWindow && !this.paymentWindow.closed) {
      this.paymentWindow.close();
    }
    
    // HTML için oluşturulan Blob URL'leri temizle
    if (!this.isResponseUrl()) {
      try {
        const blobUrl = this.createBlobUrl();
        if (blobUrl) {
          URL.revokeObjectURL(blobUrl);
        }
      } catch (e) {
        // Hata durumunda sessizce devam et
      }
    }
  }
}
